import { render, staticRenderFns } from "./promotion-edit.vue?vue&type=template&id=278f82d6&scoped=true&"
import script from "./promotion-edit.vue?vue&type=script&lang=js&"
export * from "./promotion-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f82d6",
  null
  
)

export default component.exports